import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LoaderService {
  loadingContent: EventEmitter<boolean> = new EventEmitter<boolean>();
  private lastLoadingContent: boolean | null = null;

  setLoadingContent(isLoading: boolean): void {
    if (this.lastLoadingContent === isLoading) {
      return;
    }

    this.lastLoadingContent = isLoading;
    this.loadingContent.emit(isLoading);
  }

  hideInitialLoader(): void {
    const initialLoader = document.getElementById('initial-loader');
    if (initialLoader) {
      initialLoader.style.display = 'none';
    }
  }
}
